import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAtlas } from "@/context/AtlasContext";
import { PageHeader } from "@/components/shared/PageHeader";
import { DataTable } from "@/components/shared/DataTable";
import { EmptyState } from "@/components/shared/EmptyState";
import { FormModal } from "@/components/shared/FormModal";
import { Button } from "@/components/ui/button";
import { UsersRound, Plus } from "lucide-react";
import { toast } from "sonner";

export default function Teams() {
  const { has } = useAtlas();
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const canManage = has("teams.manage");
  const load = () => api.get("/teams").then((r) => setTeams(r.data)).catch(() => {});
  useEffect(() => { load(); api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  const create = async (v) => { await api.post("/teams", { ...v, member_user_ids: v.member_user_ids || [] }); toast.success("Team created"); load(); };
  return (
    <div>
      <PageHeader title="Teams" subtitle="Group users for assignment, access and reporting">
        {canManage && <Button onClick={() => setOpen(true)} data-testid="team-create-button"><Plus className="w-4 h-4 mr-1" /> New Team</Button>}
      </PageHeader>
      {teams.length === 0 ? (
        <EmptyState icon={UsersRound} title="No teams yet" description="Create a team to group users." actionLabel={canManage ? "New Team" : undefined} onAction={() => setOpen(true)} />
      ) : (
        <DataTable testid="admin-teams-table" columns={[
          { key: "name", header: "Team", render: (r) => <span className="font-medium text-slate-900">{r.name}</span> },
          { key: "description", header: "Description", render: (r) => r.description || "—" },
          { key: "members", header: "Members", align: "right", mono: true, render: (r) => (r.member_user_ids || []).length },
        ]} rows={teams} />
      )}
      <FormModal open={open} onOpenChange={setOpen} title="New Team" testid="team-form-modal" onSubmit={create}
        fields={[
          { name: "name", label: "Team name", required: true },
          { name: "description", label: "Description" },
          { name: "member_user_ids", label: "Members", type: "multiselect", options: users.map((u) => ({ value: u.id, label: u.name })) },
        ]} />
    </div>
  );
}
